// ── POD / AWB form extractor (Claude vision via Cloud Function) ──────
// Used when a guard finds an unexpected package at the airport and
// needs to add it to the job manifest on the fly.
//
// Architecture note: this used to call Anthropic directly from the
// browser with an API key embedded in the React bundle. That exposed
// the key publicly (REACT_APP_* vars are baked into the build). We now
// call a Firebase Callable Function (functions/index.js → parsePodForm)
// which holds the key in Google Secret Manager and brokers the request
// server-side. Net effect: identical to callers, but no API key in the
// browser.

import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      const comma = result.indexOf(",");
      resolve(result.slice(comma + 1));
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function parsePodForm(file) {
  const mediaType = file.type || "image/jpeg";
  const data = await fileToBase64(file);
  const fn = httpsCallable(functions, "parsePodForm");
  // The callable returns { data: { hawbNumber, ... }, model } already
  // post-processed server-side (JSON.parse + fence-stripping).
  const result = await fn({ mediaType, data });
  return result.data;
}
